import { render, staticRenderFns } from "./privacy-policy-de.vue?vue&type=template&id=71ad19de&scoped=true"
import script from "./privacy-policy-de.vue?vue&type=script&lang=js"
export * from "./privacy-policy-de.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad19de",
  null
  
)

export default component.exports